import type React from 'react';

/*
  перемещает в конец картетку инпута на автофкусе
 */
export const moveCaretToEnd = (el: HTMLInputElement) => {
  try {
    if (document.activeElement !== el) {
      el.focus({ preventScroll: true });
    }

    const valueStr: string = (el as HTMLInputElement).value ?? '';
    const len = valueStr.length;

    if (typeof el.setSelectionRange === 'function') {
      el.setSelectionRange(len, len);
      return;
    }

    if ('selectionStart' in el && 'selectionEnd' in el) {
      const input = el as HTMLInputElement & { selectionStart: number | null; selectionEnd: number | null };
      input.selectionStart = len;
      input.selectionEnd = len;
      return;
    }

    const val = valueStr;
    (el as HTMLInputElement).value = '';
    (el as HTMLInputElement).value = val;
  } catch {}
};

export const moveCaretToEndOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
  const el = e.currentTarget;
  requestAnimationFrame(() => moveCaretToEnd(el));
};
